module.exports = __webpack_public_path__ + "static/media/sign-up-background.8822f103.png";